/**
 * File metadata display helpers shared by upload surfaces: extension parsing
 * for pre-upload validation and byte-size formatting for display labels.
 */
export class FileHelpers {
  /**
   * The lower-cased file extension including the dot, or `''` when there is
   * none.
   */
  static extension(fileName: string): string {
    const dotIndex = fileName.lastIndexOf('.');
    return dotIndex >= 0 ? fileName.slice(dotIndex).toLowerCase() : '';
  }

  /**
   * A human-readable byte size, e.g. `12.4 MB`. Sizes below 1 KB render as
   * whole bytes; larger sizes render with one decimal place.
   */
  static formatBytes(bytes: number): string {
    if (bytes < 1024) {
      return `${bytes} B`;
    }
    const units = ['KB', 'MB', 'GB'];
    let size = bytes / 1024;
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
      size = size / 1024;
      unitIndex = unitIndex + 1;
    }
    return `${size.toFixed(1)} ${units[unitIndex]}`;
  }
}
